module.exports = __webpack_public_path__ + "img/_54A6767.b5ac92cd.jpg";